import { z } from 'zod';

import { subject, action, Subject, Action } from '../permissions';

export const rolePermissionDto = z
  .object({
    subject: z.union([
      z.string(),
      z.enum(Object.values(subject) as [string, ...string[]]),
      z.array(z.union([z.string(), z.enum(Object.values(subject) as [string, ...string[]])])),
    ]),
    action: z.union([z.string(), z.array(z.string())]),
    conditions: z.record(z.any()).optional(),
    type: z.enum(['can', 'cannot']).optional(),
  })
  .refine((schema) => {
    return Object.values(action[schema.subject as Subject]).includes(
      schema.action as Action<Subject>
    );
  }, 'Invalid action for subject');

export const createRoleDto = z.object({
  name: z.string(),
  permissions: z.array(rolePermissionDto),
});

export type CreateRoleDto = z.infer<typeof createRoleDto>;
